import { useQuery } from "@/api/utils/useQuery"
import { HasuraQueries } from "@/api/hasura/queries"
import { QueryResult } from "@/api/utils/types"
import { GetWarrantsFilesAccountsSummaryQuery } from "@/api/hasura/generated/graphql"
import {
  WarrantsFilesAccountStatus,
  WarrantsFilesType,
} from "@/models/admin/warrantsFilesAccount/warrantsFilesAccount.types"
import { IWarrantsFilesSummary } from "@/models/admin/warrantsFilesSummary/warrantsFilesSummary.types"

const EMPTY_SUMMARY: IWarrantsFilesSummary = {
  status: { total: 0, pending: 0, success: 0, failed: 0 },
  types: { returns: 0, cancellation: 0 },
}

class WarrantsFilesSummaryServiceClass {
  /**
   * Overview for the DCA Files page: total ingested, a status breakdown and
   * a file-type breakdown.
   */
  getSummary(): QueryResult<IWarrantsFilesSummary> {
    return useQuery({
      ...HasuraQueries.warrants.filesAccountsSummary({
        pendingWhere: { status: { _eq: WarrantsFilesAccountStatus.PENDING } },
        successWhere: { status: { _eq: WarrantsFilesAccountStatus.SUCCESS } },
        failedWhere: { status: { _eq: WarrantsFilesAccountStatus.FAILED } },
        returnsWhere: { file_type: { _eq: WarrantsFilesType.RETURNS } },
        cancellationWhere: {
          file_type: { _eq: WarrantsFilesType.CANCELLATION },
        },
      }),
      useRawResponse: true,
      placeholderData: EMPTY_SUMMARY,
      parserFn: (
        data: GetWarrantsFilesAccountsSummaryQuery,
      ): IWarrantsFilesSummary => ({
        status: {
          total: data.total.aggregate?.count ?? 0,
          pending: data.pending.aggregate?.count ?? 0,
          success: data.success.aggregate?.count ?? 0,
          failed: data.failed.aggregate?.count ?? 0,
        },
        types: {
          returns: data.returns.aggregate?.count ?? 0,
          cancellation: data.cancellation.aggregate?.count ?? 0,
        },
      }),
    })
  }
}

export const WarrantsFilesSummaryService =
  new WarrantsFilesSummaryServiceClass()
